module.exports = __webpack_public_path__ + "public/SiteIcons/wavingHand.png?a05ab80a";